module.exports = __webpack_public_path__ + "static/media/CTLA_10-540w.f33444d8.jpg";